import { parse, parseISO, isValid } from 'date-fns'

/**
 * Converte string de data para Date.
 * Aceita ISO (YYYY-MM-DD, com ou sem time), BR (dd/MM/yyyy) e dd-MM-yyyy.
 * Retorna null se vazio ou inválido.
 */
export const parseCompetenceDate = (value: string | null | undefined): Date | null => {
  if (value == null || String(value).trim() === '') return null

  const str = String(value).trim()

  const iso = parseISO(str)
  if (isValid(iso)) return iso

  const brSlash = parse(str, 'dd/MM/yyyy', new Date())
  if (isValid(brSlash)) return brSlash

  const brDash = parse(str, 'dd-MM-yyyy', new Date())
  if (isValid(brDash)) return brDash

  return null
}
